import { render, staticRenderFns } from "./CommentConfirmDetails.vue?vue&type=template&id=0aff282a&"
import script from "./CommentConfirmDetails.vue?vue&type=script&lang=ts&"
export * from "./CommentConfirmDetails.vue?vue&type=script&lang=ts&"
import style0 from "./CommentConfirmDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports